<template>
  <div class="account-wrapper">
    <ModalConfirm
      :isVisible="confirmDialog.isVisible"
      :content="confirmDialog.content"
      @closeDialogHandler="closeDialogHandler"
    />
    <ModalAlert
      :isVisible="alertDialog.isVisible"
      :content="alertDialog.content"
      @closeDialogHandler="closeAlertDialogHandler"
      :is-btn="true"
    />
    <div class="info-area">
      <p class="acc">{{ $t("trading.account.account") }}</p>
      <div class="ac-info">
        <p>{{ $t("trading.account.balance") }}</p>
        <!-- <span>{{ formatNumberWithComma(userWallet.balance) }}USDT</span> -->
        <span>{{ formatNumberWithComma(totalBalance) }}USDT</span>
      </div>
      <div class="ac-info">
        <p>{{ $t("trading.account.unPnl") }}</p>
        <span v-if="positionList.length === 0">0USDT</span>
        <span
          v-else
          :class="
            unrealizePnl > 0
              ? 'txt-plus'
              : unrealizePnl < 0
              ? 'txt-minus'
              : null
          "
        >
          {{ unrealizePnl > 0 ? "+" : "" }} {{ unrealizePnl }}USDT
        </span>
      </div>
    </div>
    <div class="btn-area" v-if="userNo">
      <!-- <button v-if="!userState" @click="startSimultion()">
        {{ $t("trading.account.ss") }}
      </button> -->
      <button
        v-if="!userState"
        @click="startSimultion()"
        :class="isDarkMode ? 'dark' : 'light'"
      >
        {{ $t("trading.account.ss") }}
      </button>
      <!-- <button :class="{ disabled: btnDisabled }" v-if="userState" :disabled="btnDisabled"
                @click="deposit()">Deposit</button> -->
      <button
        :class="{ disabled: btnDisabled }"
        v-if="userState"
        @click="resetBalance()"
      >
        {{ $t("trading.account.rb") }}
      </button>
    </div>
    <!-- <modal-frame :isVisible="balancePopup" :width="'400px'" :isOverlay="true" @closeDialogHandler="closeHandler(0)">
            <div class="modal_title">s
                <h4>Top Up Balance</h4>
                <button class="close-btn" @click="closeHandler(0)">×</button>
            </div>
            <div class="modal_body">
                <p>Max Available: <span>{{ formatNumberWithComma(maxAvail) }}</span>USDT</p>
                <div>
                    <p>Charge Amount </p>
                    <input type="text" v-model="chargeBalance" @input="checkChargeAmount" />
                    <p class="ab">USDT</p>
                </div>
            </div>
            <div class="col-12 text-center modal_btn">
                <button type="button" class="btn btn-primary mlr-5" @click="closeHandler(1)">Confirm</button>
            </div>
        </modal-frame> -->
  </div>
</template>

<script setup>
import ModalFrame from "@/components/common/modal/ModalFrame.vue";
import ModalConfirm from "@/components/common/modal/ModalConfirm.vue";
import ModalAlert from "@/components/common/modal/ModalAlert.vue";
import { formatDecimal, formatNumberWithComma } from "@/utils/order";
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const AVAILD_CHARGE = 3000;
const MAX_CHARGE = 10000;
const store = useStore();
const alertDialog = ref({
  isVisible: false,
  key: "",
  content: "",
});
const confirmDialog = ref({
  isVisible: false,
  key: "",
  content: "",
});
const balancePopup = ref(false);
const chargeBalance = ref(null);
const userNo = computed(() => store.state.account.userNo);
const reCode = computed(() => store.state.account.reCode);
const userState = computed(() => store.state.account.userState);
const userWallet = computed(() => store.state.account.userWallet);
const unrealizePnl = computed(() => store.state.account.unrealizePnl);
const positionList = computed(() => store.state.user_history.positionList);
const isDarkMode = computed(() => store.getters["displayed/isDarkMode"]);
const maxAvail = computed(() => {
  const v = MAX_CHARGE - userWallet.value.balance;
  return formatDecimal(v, 2);
});
const btnDisabled = computed(() => {
  return Number(userWallet.value.balance) > AVAILD_CHARGE;
});
const fetchAll = async () => {
  await Promise.all([
    store.dispatch("account/fetchUserWallet"),
    store.dispatch("user_history/fetchAllHistory", userNo.value),
  ]);
};
const startSimultion = async () => {
  if (userState.value) return;
  confirmDialog.value.isVisible = true;
  confirmDialog.value.key = "start";
  confirmDialog.value.content = t("trading.account.startMsg");
};
// const deposit = () => {
//     if (btnDisabled.value) return;
//     balancePopup.value = true;
// }

const totalBalance = computed(() => {
  const balance = Number(userWallet.value?.balance || 0);
  const pnl = Number(unrealizePnl.value || 0);

  // pnl이 NaN일 경우 0으로 처리하는 방어 로직
  const safePnl = isNaN(pnl) ? 0 : pnl;

  return balance + safePnl;
});

const resetBalance = () => {
  if (btnDisabled.value) {
    alertDialog.value.isVisible = true;
    alertDialog.value.content = t("trading.account.resetCaution", {
      num: formatNumberWithComma(AVAILD_CHARGE),
    });
    return;
  }
  confirmDialog.value.isVisible = true;
  confirmDialog.value.key = "reset";
  confirmDialog.value.content = t("trading.account.resetMsg");
};

const closeDialogHandler = async (payload) => {
  confirmDialog.value.isVisible = false;
  if (payload === 1) {
    if (confirmDialog.value.key === "start") {
      await store.dispatch("account/postStartTrading");
      await store.dispatch("account/fetchUserState");
      await store.dispatch("account/fetchUserWallet");
    } else if (confirmDialog.value.key === "deposit") {
      await store.dispatch("account/fetchUserWallet");
    } else if (confirmDialog.value.key === "reset") {
      await store.dispatch("account/postResetUser");
      await fetchAll();
    }

    if (reCode.value !== 0) {
      alertDialog.value.isVisible = true;
      alertDialog.value.content = t(`trading.error.${reCode.value}`);
    }
  }
};
// const checkChargeAmount = (e) => {
//     let val = e.target.value;
//     val = val.replace(/[^0-9.]/g, '')
//         .replace(/\.{2,}/g, '.')
//         .replace(/^(\d*\.\d{0,2}).*$/, '$1');
//     if (val.startsWith('.')) {
//         val = '0' + val;
//     }
//     if (parseFloat(val) > maxAvail.value) {
//         val = maxAvail.value;
//     }
//     e.target.value = val;
// };
const closeAlertDialogHandler = () => {
  alertDialog.value.isVisible = false;
};
// const closeHandler = async (isConfirm) => {
//     if (isConfirm) {
//         if (chargeBalance.value > MAX_CHARGE) return;
//         await store.dispatch("account/postChargeSeed", chargeBalance.value);
//         if (reCode.value !== 0) {
//             alertDialog.value.isVisible = true;
//             alertDialog.value.content = "An error occurred. Please try again later."
//         } else {
//             await fetchAll();
//             balancePopup.value = false;
//         }
//     } else {
//         balancePopup.value = false;
//     }

// };
</script>

<style lang="scss" scoped>
.account-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 30px;

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
}

.acc {
  position: relative;
  top: 5px;
  margin-bottom: 15px;
}

.ac-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  p {
    color: #818181;
  }
}

.btn-area {
  button {
    height: 30px;
    width: 100%;
    border-radius: 5px;
    font-family: Pretendard;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px; /* 142.857% */
    letter-spacing: -0.14px;
    &:not(.disabled):hover {
      background-color: #000;
      color: #fff;
    }

    &.light {
      color: #fff;
    }

    &.disabled {
      background: var(--bs-board-bg);
    }
  }
}

.modal_body {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 20px;

  > p {
    font-size: 1.5rem;
    letter-spacing: 0.3px;

    span {
      font-size: 2rem;
      color: var(--primary-color);
    }
  }

  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    gap: 10px;

    input {
      padding: 0 50px 0 10px;
      width: 100%;
      max-width: 200px;
    }

    .ab {
      right: 10px;
    }
  }
}
</style>
